import { gsap } from 'gsap';
    
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function historyScroll(){
    let mm = gsap.matchMedia();
    mm.add('(min-width: 991px)', () => {
        let years = gsap.utils.toArray('.year');
        let yearsContainer = document.querySelector('.years-container-wrap');
        let scrollYearsAnim = gsap.to(years, {
            translateX: -(yearsContainer.scrollWidth - window.innerWidth) + 'px',
            ease: 'none',
            scrollTrigger: {
                trigger: '.history-scroll-trigger',
                pin: true,
                start: 'center center',
                end: "+=50%",
                scrub: true,
                invalidateOnRefresh: true,
            }
        });
    });
}

export { historyScroll }